var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardImage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 48,
    viewBox: "0 0 67 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 33.5,
    cy: 33.2505,
    rx: 12.5,
    ry: 12.5002,
    fill: "#62CABC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 8.57915L53.0639 9.55808C53.0214 9.5796 52.9773 9.59805 52.9321 9.61328L50.279 10.5076C50.0969 10.569 49.9009 10.5766 49.7145 10.5295L48 10.096L46.1073 9.61753C46.036 9.5995 45.9669 9.57365 45.9012 9.54045L44.1453 8.65263C44.0491 8.60396 43.9613 8.54004 43.8855 8.46336L42.8198 7.38562C42.3888 6.94977 41.6706 7.00072 41.3055 7.49306L40.5756 8.47722C40.5254 8.5449 40.4669 8.60596 40.4013 8.65896L38.0827 10.5347C38.0277 10.5792 37.9682 10.6178 37.905 10.6497L36 11.6129L35 12.1185",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 45.7925C65 35.8514 56.9411 27.7925 47 27.7925V27.7925C37.0589 27.7925 29 35.8514 29 45.7925V45.995H65V45.7925Z",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 30.8267L53.2534 32.6783C53.0882 32.7897 52.8936 32.8492 52.6944 32.8492H41.3056C41.1064 32.8492 40.9118 32.7897 40.7466 32.6783L38 30.8267",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 3C51.2309 3 55.5 7.29285 55.5 12.6238C55.5 17.9547 51.2309 22.2476 46 22.2476C40.7691 22.2476 36.5 17.9547 36.5 12.6238C36.5 7.29285 40.7691 3 46 3ZM58.5 12.6238C58.5 5.66773 52.9193 0 46 0C39.0807 0 33.5 5.66773 33.5 12.6238C33.5 19.5798 39.0807 25.2476 46 25.2476C52.9193 25.2476 58.5 19.5798 58.5 12.6238Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.54504L13.9362 9.51936C13.9787 9.54072 14.0226 9.55903 14.0677 9.57415L16.7222 10.4646C16.9036 10.5255 17.0986 10.533 17.2842 10.4863L19 10.0546L20.893 9.57836C20.9641 9.56047 21.033 9.53482 21.0985 9.50186L22.8547 8.61813C22.951 8.56972 23.0387 8.50609 23.1146 8.4297L24.1822 7.35531C24.6129 6.92184 25.3282 6.97264 25.6933 7.46261L26.4242 8.44327C26.4745 8.51084 26.5332 8.57178 26.5989 8.62464L28.9173 10.4912C28.9723 10.5355 29.0318 10.5739 29.0949 10.6056L31 11.5643L32 12.0675",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 45.7818C2 35.8407 10.0589 27.6665 20 27.6665V27.6665C29.9411 27.6665 38 35.8407 38 45.7818V45.7818H2V45.7818Z",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30.686L13.7472 32.5293C13.912 32.6398 14.106 32.6988 14.3044 32.6988H25.6956C25.894 32.6988 26.088 32.6398 26.2528 32.5293L29 30.686",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3C15.7623 3 11.5 7.2758 11.5 12.5705C11.5 17.8651 15.7623 22.1409 21 22.1409C26.2377 22.1409 30.5 17.8651 30.5 12.5705C30.5 7.2758 26.2377 3 21 3ZM8.5 12.5705C8.5 5.63704 14.0874 0 21 0C27.9126 0 33.5 5.63704 33.5 12.5705C33.5 19.5039 27.9126 25.1409 21 25.1409C14.0874 25.1409 8.5 19.5039 8.5 12.5705Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage2);
export default __webpack_public_path__ + "static/media/card-image2.7181fc41a3f1b12919e1c20f6dde25fb.svg";
export { ForwardRef as ReactComponent };